var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'action-favorites ' + _vm.fname,
    _vm.backGroundIsDark ? 'background-dark' : '' ],attrs:{"title":_vm.isFavorite
      ? _vm.translate('message.favorites.remove')
      : _vm.translate('message.favorites.add')},on:{"click":function($event){return _vm.toggleFavorite($event)}}},[_c('button',{staticClass:"favorite-button"},[_c('font-awesome-icon',{attrs:{"icon":[_vm.isFavorite ? 'fas' : 'far', 'star']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }